import classNames from 'classnames';
import { usePathname } from 'next/navigation';

import type { FooterMenuItem } from '~/shared/components/footer/types';
import NextLink from '~/shared/components/link';
import { type Locale, PAGE_NAMES } from '~/shared/constants';
import { getLocaleLink, isItemSelected } from '~/shared/helpers/browser-helpers';
import { useTypedTranslation } from '~/shared/hooks';

import './footer-nav.scss';

type FooterNavProps = Readonly<{
  lng: Locale;
}>;

const FooterNav = ({ lng }: FooterNavProps) => {
  const t = useTypedTranslation(['page']);
  const pathname = usePathname();
  const menuItems: readonly FooterMenuItem[] = [
    {
      key: `/${lng}`,
      href: getLocaleLink(PAGE_NAMES.HOME, lng),
      label: t('page.home.menu-item'),
    },
    {
      key: getLocaleLink(PAGE_NAMES.BLOG, lng),
      href: getLocaleLink(PAGE_NAMES.BLOG, lng),
      label: t('page.blog.menu-item'),
      activePaths: [getLocaleLink(PAGE_NAMES.BLOG, lng)],
    },
    {
      key: getLocaleLink(PAGE_NAMES.COURSES, lng),
      href: getLocaleLink(PAGE_NAMES.COURSES, lng),
      label: t('page.courses.menu-item'),
      activePaths: [getLocaleLink(PAGE_NAMES.COURSES, lng)],
    },
    {
      key: getLocaleLink(PAGE_NAMES.ABOUT_US, lng),
      href: getLocaleLink(PAGE_NAMES.ABOUT_US, lng),
      label: t('page.about-us.menu-item'),
    },
    {
      key: getLocaleLink(PAGE_NAMES.CONTACTS, lng),
      href: getLocaleLink(PAGE_NAMES.CONTACTS, lng),
      label: t('page.contacts.menu-item'),
    },
  ];

  return (
    <nav className="footer-nav" aria-label="Footer navigation">
      <ul className="footer-nav__nav-list">
        {menuItems.map((item) => {
          const { key, href, label } = item;
          return (
            <li key={key} className="footer-nav__nav-item">
              <NextLink
                href={href}
                className={classNames('footer-nav__nav-link', {
                  'footer-nav__nav-link--selected': isItemSelected(item, pathname),
                })}
              >
                {label}
              </NextLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default FooterNav;
